export default __webpack_public_path__ + "static/media/session_as_mentor.0c011131.svg";